import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import * as models from '../../models'; 

export interface IApiStatusService {
  getApiStatus(request: string): Observable<models.ApiStatus>;
}

export const API_STATUS_SERVICE_TOKEN = new InjectionToken('Shared.IApiStatusService');
